import { UserPropertyForm, type UserPropertyFormProps } from 'app/src/features/UserInfo/components/UserPropertyForm'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function UserDataCard(props: UserPropertyFormProps & { showEdit?: boolean }): ReactElement {
  const { t } = useTranslation('userInfo', { keyPrefix: 'UserInfo.UserDataCard' })
  const [formEditMode, setFormEditMode] = useState<boolean>(false)

  return formEditMode ? (
    <UserPropertyForm {...props} onClose={() => setFormEditMode(false)}></UserPropertyForm>
  ) : (
    <Card
      data-testid={`UserDataCard`}
      className='flex-1'
      title={props.propertyDisplayName}
      footer={
        props.showEdit && (
          <Button
            rounded
            text
            className='m-0 p-0'
            onClick={() => {
              setFormEditMode(true)
            }}
          >
            {t('Update')}
          </Button>
        )
      }
    >
      <p>
        {props.propertyFormatter?.format
          ? props.propertyFormatter.format(props.propertyValue ?? '-')
          : (props.propertyValue ?? '-')}
      </p>
    </Card>
  )
}
